<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UtvNwm/tc-custom/9783988269676.jpg?1704453361509" alt="This image is the cover for the book Holly Berries From Dickens, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Holly Berries From Dickens, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Originally published in Boston in 1898 as a small format gift book, complete with its own box, Holly Berries from Dickens seemed to promise a Christmas book of a sort. It isn't. At least not directly. Something quite different awaits inside. These holly berries comprise over 120 quotations from just over 20 works by Charles Dickens including his Christmas stories and the author himself. Presented as a series for each day from Day 1 to Day 31, some quotations, such as “The will to do well . . . is the next thing to having the power”, are attributed to one of his characters, in this case Mr Pecksniff. Other attributions are to one of his works by title, as in “Energy and determination have done wonders many a time” from Bleak House. A few, including “It does not follow that the more talkative a person becomes the more agreeable he is” carry the simple tag Dickens. These holly berries are in season year-round.(amazon)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Dickens
      </h2>
      
      <p class="authorDescription body article">Charles Dickens (1812-1870) was one of the most celebrated English novelists of the 19th century. He is known for his vivid characters, intricate plots, and social commentary, which exposed the inequalities and injustices of Victorian society. Dickens' works remain widely read and influential, and he is considered a literary giant of English literature. Charles Dickens' writing is cherished not only for its literary merit but also for its enduring social relevance. His novels remain essential for those interested in understanding the complexities of Victorian society and the human condition. Dickens' work continues to captivate readers and inspire writers to this day.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73c980e4